export default "__VITE_ASSET__zi9fo5LX__"